export const COLUMN_HEADINGS = [
  { label: "Date", value: "Date" },
  { label: "Description", value: "Description" },
  { label: "Fund Units", value: "Fund Units" },
  { label: "NAV", value: "NAV" },
  { label: "Gross Amount", value: "Gross Amount" },
  { label: "Load", value: "Load" },
  { label: "Tax", value: "Tax" },
  { label: "Net Amount", value: "Net Amount" },
  { label: "Closing Units", value: "Closing Units" },
  { label: "Balance", value: "Balance" },
];

export const REDEEMED_TYPES = [
  "zakatondividend",
  "zakatonbonusencashment",
  "dividendpaid",
  "taxondividend",
  "taxonbonusencashment",
  "bonusencashment",
  "transferlienout",
  "transferout",
  "conversionout",
  "redemptionofunits",
];

export const UNIT_SOLD_TYPES = [
  "cgtrefund",
  "refundofcapital",
  "dividendreinvestment",
  "dividend",
  "bonus",
  "transferlienin",
  "transferin",
  "conversionin",
  "saleofunit",
];

export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, "All"];
